import { useEffect, useSyncExternalStore } from 'react';
import { useAppSelector } from '@platform/state/hooks';
import { selectDialog } from '@platform/state/selectors';
import { newRecordPreset } from './newRecordPreset';

/**
 * Початкові значення нового запису, задані поданням (newRecordPreset), або null; закриття діалогу створення їх скидає, тож інші кнопки
 * створення (меню, панель) відкривають порожній діалог.
 */
export function useNewRecordPreset(): Readonly<Record<string, string>> | null {
  const kind = useAppSelector(selectDialog).kind;
  useEffect(() => { if (kind === null && newRecordPreset.get()) newRecordPreset.set(null); }, [kind]);
  return useSyncExternalStore(newRecordPreset.subscribe, newRecordPreset.get, newRecordPreset.get);
}
